// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import EditVariant from '../_raw/ui/icon_edit_variant.svg';
import withIconProps from '../withIconProps';

export default withIconProps(EditVariant);
